import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import { Context } from '../../context/DataContext';

const OrderCompletedPage = () => {
  const navigate = useNavigate();
  const { state, } =
    React.useContext(Context);
  const {
    loginInfo: { tokenLogin, token },
  } = state;

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        延保交易完成
      </Typography>
      <Box>
        <Typography
          variant='h6'
          sx={{ px: 2, my: 2, textAlign: 'left' }}>
          謝謝您購買本商品服務，立格科技為本專案指定的售後服務商！若您手機有任何維修的需求，請務必回原購買門市送修，以確保您的權益！
        </Typography>
        <Button
          color='info'
          variant='contained'
          sx={{ width: 168 }}
          onClick={() => {
            if (tokenLogin) {
              navigate('/?t=' + token);
            } else {
              // Send check e-mail to customer
              navigate('/login');
            }
          }}>
          結束
        </Button>
      </Box>
    </Box>
  );
};

export default OrderCompletedPage;
